module.exports = "../fonts/facebook_registration.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook_registration.svg
// module id = 92
// module chunks = 0